// node_modules
import { CSSProperties, FC, useEffect, useRef, useState } from "react";
import { faSortAmountUp, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// Components
import { PositionedPopup } from "Components";
// Style
import styles from "./sortByContainer.module.scss";
// Custom hooks
import { useClickOutsideRef } from "Hooks";

type SortByContainerProps = {
    children: (JSX.Element | null)[]
    extraStyle?: CSSProperties,
    selectedName: string,
    onSortingChange?: (text: string) => void
};

export const SortByContainer: FC<SortByContainerProps> = ({extraStyle, selectedName, children, onSortingChange}: SortByContainerProps) => {
    // State
    const [selectedSortingName, setSelectedSortingName] = useState(selectedName);
    const [isCollapsed, setIsCollapsed] = useState(true);

    // Ref
    const positionedPopupContainerRef = useRef<HTMLDivElement | null>(null);

    // Logic
    useEffect(() => {
        setSelectedSortingName(selectedName);
    }, [selectedName]);

    const handleClickOutsideRef = (): void => {
        setIsCollapsed(true);
    };

    useClickOutsideRef(positionedPopupContainerRef, handleClickOutsideRef);
    
    const onSortingClick = (text: string) => {
        setSelectedSortingName(text);
        setIsCollapsed(true);
        if(onSortingChange) onSortingChange(text);
    };

    return (
        <div style={{position: "relative"}}>
            <div className={styles.sortByContainer} style={extraStyle}>
                <FontAwesomeIcon icon={faSortAmountUp} />
                <span> Sort By </span>
                <span onClick={() => { setIsCollapsed(!isCollapsed); }} style={{cursor: "pointer", padding: "0"}}>
                    <span className={styles.selectedOption}>{selectedSortingName}</span>
                    {isCollapsed ? <FontAwesomeIcon icon={faChevronDown} />
                        : <FontAwesomeIcon icon={faChevronUp} /> }
                </span>
            </div>
            {!isCollapsed ? 
                <div ref={positionedPopupContainerRef} style={{color: "black", position: "absolute", right: 0}}>
                    <PositionedPopup>
                        {children.map((child, index) => {
                            if(!child) return null;
                            return (
                                <div className={styles.option} key={index} onClick={() => { onSortingClick(child.props.title); }}>{child.props.title}</div>
                            );
                        })}
                    </PositionedPopup>
                </div>
                : <></>
            }
        </div>
    );
};